<template>
  <v-card style="overflow: auto">
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">

      <v-data-table
        :pagination.sync="paginationList"
        :rows-per-page-items="paginationList.rowsPerPageItems"
        :total-items="squareCommissions.TotalRegistros"
        @update:pagination="searchPagination(paginationList.page ,paginationList.rowsPerPage)"
        :items="squareCommissions.Data"
        :headers="headers"
        class="v-table-list theme--light table-default"
      >
        <template slot="items" scope="props">
          <tr v-bind:class="{table__selected:props.selected}">
            <td width="1%">
              
            </td>
            <!-- <td
              class="text-xs-left cut-text"
            >{{moment(props.item.creationDate,"DD/MM/YYYY HH:mm").format('DD/MM/YYYY HH:mm')}}</td> -->
            <td class="text-xs-left cut-text corto-min">{{ props.item.identificacion }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.NombreCliente }}</td>
            <td class="text-xs-left cut-text grande-min">{{ props.item.IdBeneficiario }}</td>
            <td class="text-xs-left cut-text extragrande-min">{{ props.item.NombreBeneficiario }}</td>
            <td class="text-xs-left cut-text grande-min">{{ props.item.CodigoPoliza }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.FacturaReal }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.PrimaNeta | currency }}</td>
            <td class="text-xs-left cut-text corto-min">{{ props.item.ValorComision | currency }}</td>
            <td class="text-xs-left cut-text medio-min">
              <v-btn flat icon color="primary" @click="openModal(props.item)">
                <v-icon @click="openModal(props.item)">remove_red_eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>

        <template slot="no-data">
          <div>{{$t('message.noSquareComission')}}</div>
        </template>
        <!-- <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>  -->
      </v-data-table>
   
    </v-card-text>

    <square-comission-modal ref="squareComissionModal"></square-comission-modal>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import SquareComissionModal from "./SquareComissionModal.vue";

export default {
  props: {
       filters:{
        type:Object
       }

  },

  components:{
    SquareComissionModal,
  },
  computed: {
    ...mapGetters(["loadingCommission", "agency","squareCommissions"])
  },
  methods: {
    nzDate: nzDate,
    openModal(data){
      this.$refs.squareComissionModal.openDialog(data);
    },
    searchPagination(page, limit) {
      this.filters.pagination = {
      Page:page,
      Limit:limit,
    };
      this.getSquareCommission();
    },
    getSquareCommission(){
    this.$store.dispatch("getSquareCommission", this.filters);
  },
  }, 
  mounted() {
    this.getSquareCommission();
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },

  },
  data() {
    return {
      scrollSync : {
            top: 0,
            left: 0
         },
      selectedValue: null,
      selectRow: 0,
      additional_grouped: [],
      searchValue: "",
      matches: [],
      selected: [],
      paginationList:{},
      headers: [
        {
          align: "left",
          sortable: false,
          text: "",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Identificación cliente",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Nombre cliente",
          value: "",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: "Identificación beneficiario",
          value: "",
          width: "10%"
        },
        {
          align: "left",
          sortable: false,
          text: "Nombre beneficiario",
          value: "",
          width: "20%"
        },
        {
          align: "left",
          sortable: false,
          text: "Póliza",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "No Factura",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Prima neta",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Valor comisión",
          value: "",
          width: "5%"
        },
        {
          align: "left",
          sortable: false,
          text: "Acciones",
          value: "",
          width: "5%"
        }
      ]
    };
  }
};
</script>
<style scoped>
.medio-min{
   min-width: 120px;
 }

.grande-min{
   min-width: 150px;
 }

 .extragrande-min{
   min-width: 200px;
 }
 .corto-min{
   min-width: 80px;
 }
</style>